import Canvas from "./Canvas";
import requestHelper from "./../api/requestHelper";
import AppDebug from "./../AppDebug";
import ProductConfiguration from "./ProductConfiguration";
import BoundingBox from "./canvas-objects/BoundingBox";
import AdminBoundingBox from "./canvas-objects/AdminBoundingBox";

class AdminProductConfiguration extends ProductConfiguration {

    /**
     * Create a AdminProductConfiguration.
     */
    constructor() {

        super(null);

        console.log('runs in admin mode');

        this._productConfigurationViews = [
            this.createProductConfigurationView()
        ];

    }

    /**
     * Create a new ProductConfigurationView.
     * @return {Object} productConfigurationView
     */
    createProductConfigurationView() {

        /**
         * @type {
         *     {
         *         id: number,
         *         productId: number,
         *         viewImageId: number,
         *         viewPreviewImage: number,
         *         canvas: ?Canvas,
         *         active: ?boolean,
         *         preview: {?string} url to preview image,
         *         productView: {
         *             id: number
         *         },
         *         title: string,
         *         boundingBox: {
         *             x: {
         *                 min: number,
         *                 max: number,
         *                 current: number
         *             },
         *             y: {
         *                 min: number,
         *                 max: number,
         *                 current: number
         *             },
         *             sizes: {
         *                 height: number,
         *                 width: number
         *             }
         *         },
         *         canvasHeight: number,
         *         canvasWidth: number,
         *         description: string,
         *         dpi: number,
         *         factor: number,
         *         printArea: string,
         *         printType: string,
         *     }
         * }
         */
        const blueprint = JSON.parse(window.view);

        //const blueprint = JSON.parse('{"active":true,"id":1,"title":"Flasche: linke Seite","description":"Druckfläche: ca. 30x60cm","printType":"Tampondruck (1c)","printArea":"ca. 30x60cm","previewId":2,"backgroundId":1,"boundingBox":{"x":{"max":93,"min":93,"current":93},"y":{"max":320,"min":149,"current":149},"sizes":{"width":60,"height":120}},"productId":1,"canvasHeight":520,"canvasWidth":280,"dpi":300,"factor":5,"backgroundUrl":"http://localhost/web2print/backend/public/api/viewimage/1","previewUrl":"http://localhost/web2print/backend/public/api/viewimage/2"}');

        if (! blueprint.boundingBox.hasOwnProperty('x'))
            blueprint.boundingBox = {
                x: {
                    min: 0,
                    max: 0,
                    current: 0
                },
                y: {
                    min: 0,
                    max: 0,
                    current: 0
                },
                sizes: {
                    height: 0,
                    width: 0
                }
            };

        blueprint.canvas = new Canvas(
            requestHelper.createUrl(`/viewimage/${blueprint.viewImageId}`),
            blueprint.id,
            blueprint.dpi,
            blueprint.factor
        );

        blueprint.canvas._factor = blueprint.factor;

        // Bug das mind. maxY überschrieben wird passiert erst zu einem späteren Zeitpunkt, bei der initialisierung ist der Wert noch korrekt
        const boundingBox = new AdminBoundingBox(blueprint.canvas, blueprint.boundingBox.x.min, blueprint.boundingBox.x.max, blueprint.boundingBox.y.min, blueprint.boundingBox.y.max);

        boundingBox.set({
            top: blueprint.boundingBox.y.current,
            left: blueprint.boundingBox.x.current,
            height: blueprint.boundingBox.sizes.height,
            width: blueprint.boundingBox.sizes.width
        });

        blueprint.canvas.addCanvasObject(
            boundingBox
        );

        blueprint.active = true;
        blueprint.preview = requestHelper.createUrl(`/viewimage/${blueprint.previewId}`);
        blueprint.productView = {
            id: blueprint.id
        };
        blueprint.id = 'pcv_' + Math.random().toString(36).substr(2, 9) + new Date().getTime();

        console.log(`AdminProductConfig Line 123:`);
        console.log(blueprint);

        return blueprint;

    }

}

export default AdminProductConfiguration;